export enum UploadStepEnum {
  SELECT_FILES,
  UPLOAD_START,
  UPLOAD_END_SUCCESS,
  UPLOAD_END_ERROR,
  ATTACH_START,
  ATTACH_END_SUCCESS,
  ATTACH_END_ERROR,
}
